import styled, { css } from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'
import { CardContent } from '../HotelCart/styles'

type ContainerProps = {
  horizontalOrientation?: boolean
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const CartTitle = styled.h3<ContainerProps>`
  font-size: ${({ horizontalOrientation }) => (horizontalOrientation ? '12px' : '14px')};
  font-weight: 700;
  color: #273240;
  margin: 0;
`

export const CartItemsContainer = styled(CardContent)<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;

  ${({ horizontalOrientation }) => {
    if (horizontalOrientation) {
      return css`
        padding: unset;
        min-height: unset !important;

        & > *:not(:first-child):not(:last-child) {
          margin-bottom: 15px !important;
        }
      `
    }
  }}
`

export const CartItemsContainerWithoutIsCartView = styled.div`
  background-color: ${({ theme }) => theme?.colors?.white};
  color: ${({ theme }) => theme?.colors?.textColor};

  padding-bottom: 0px;

  p {
    margin-bottom: 0px;
    margin-top: 0px;
  }

  @media (min-width: calc(${BREAKPOINT_SM})) {
    width: 348px;
    padding-bottom: 20px;
  }
`

export const DividerContainer = styled.div`
  padding: 20px;
`
